export const ADDRESS1 = '910 Fairmount Avenue';
export const ADDRESS2 = 'Philadelphia, PA 19123';
export const ADDRESS3 = '';
export const NOTICE1 = 'Studio Hours Tue-Sat 9a-5p';
export const NOTICE2 = 'Closed Sunday & Monday';
export const PHONE_NUMBER = '';
export const EMAIL = 'info@papertini.com | @papertinievents';
export const COPYRIGHT = `©PAPERTINI ${new Date().getFullYear()}`;
